/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Title_AccentInputs */

const en_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golf teacher.`)
};

const es_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de Iowa.`)
};

const de_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflehrer.`)
};

const zh_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫老师。`)
};

const ar_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في Iowa.`)
};

const fr_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`le plus honoré de l'Iowa.`)
};

const vi_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa.`)
};

const sw_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anayeheshimika zaidi Iowa.`)
};

const th_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่ได้รับเกียรติมากที่สุดในไอโอวา`)
};

const bs_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`u Iowi.`)
};

const ja_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフ教師。`)
};

const ko_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프 지도자.`)
};

const pt_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais premiado de Iowa.`)
};

const it_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`più premiato dell'Iowa.`)
};

const sv_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golflärare.`)
};

const nl_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golfleraar.`)
};

const da_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golflærer.`)
};

const nb_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golflærer.`)
};

const fi_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golfopettaja.`)
};

const pl_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w stanie Iowa.`)
};

const ru_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`учитель гольфа в Айове.`)
};

const tr_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golf öğretmeni.`)
};

const hi_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ शिक्षक।`)
};

const id_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di Iowa.`)
};

const ms_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di Iowa.`)
};

const cs_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`v Iowě.`)
};

const el_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`δάσκαλος γκολφ της Iowa.`)
};

const he_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המכובד ביותר באיווה.`)
};

const af_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gholfafrigter.`)
};

const hu_about_title_accent = /** @type {(inputs: About_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`golfoktatója.`)
};

/**
* | output |
* | --- |
* | "golf teacher." |
*
* @param {About_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_title_accent = /** @type {((inputs?: About_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_title_accent(inputs)
	if (locale === "de") return de_about_title_accent(inputs)
	if (locale === "zh") return zh_about_title_accent(inputs)
	if (locale === "ar") return ar_about_title_accent(inputs)
	if (locale === "fr") return fr_about_title_accent(inputs)
	if (locale === "vi") return vi_about_title_accent(inputs)
	if (locale === "sw") return sw_about_title_accent(inputs)
	if (locale === "th") return th_about_title_accent(inputs)
	if (locale === "bs") return bs_about_title_accent(inputs)
	if (locale === "ja") return ja_about_title_accent(inputs)
	if (locale === "ko") return ko_about_title_accent(inputs)
	if (locale === "pt") return pt_about_title_accent(inputs)
	if (locale === "it") return it_about_title_accent(inputs)
	if (locale === "sv") return sv_about_title_accent(inputs)
	if (locale === "nl") return nl_about_title_accent(inputs)
	if (locale === "da") return da_about_title_accent(inputs)
	if (locale === "nb") return nb_about_title_accent(inputs)
	if (locale === "fi") return fi_about_title_accent(inputs)
	if (locale === "pl") return pl_about_title_accent(inputs)
	if (locale === "ru") return ru_about_title_accent(inputs)
	if (locale === "tr") return tr_about_title_accent(inputs)
	if (locale === "hi") return hi_about_title_accent(inputs)
	if (locale === "id") return id_about_title_accent(inputs)
	if (locale === "ms") return ms_about_title_accent(inputs)
	if (locale === "cs") return cs_about_title_accent(inputs)
	if (locale === "el") return el_about_title_accent(inputs)
	if (locale === "he") return he_about_title_accent(inputs)
	if (locale === "af") return af_about_title_accent(inputs)
	if (locale === "hu") return hu_about_title_accent(inputs)
	return en_about_title_accent(inputs)
});